<svg
  width="20"
  height="20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
>
  <path
    d="m1.667 5.833 6.804 4.763c.55.386.826.579 1.126.654.265.066.542.066.806 0 .3-.075.575-.268 1.126-.654l6.804-4.763M5.667 16.668h8.666c1.4 0 2.1 0 2.635-.273a2.5 2.5 0 0 0 1.093-1.092c.272-.535.272-1.235.272-2.635V7.334c0-1.4 0-2.1-.272-2.635a2.5 2.5 0 0 0-1.093-1.093c-.534-.272-1.235-.272-2.635-.272H5.667c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.093c-.272.534-.272 1.234-.272 2.635v5.333c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.092c.535.273 1.235.273 2.635.273Z"
    stroke="currentColor"
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
